import { RouterStateSnapshot, convertToParamMap } from '@angular/router';

import { ActionReducerMap } from '@ngrx/store';
import { RouterStateSerializer, routerReducer } from '@ngrx/router-store';

import { RouterState, RouterStateUrl } from './router.state';

export const routerFeatureKey = 'router';

export const reducers: ActionReducerMap<RouterState> = {
  router: routerReducer,
};

export class CustomSerializer implements RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    let route = routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const { url } = routerState;
    const { paramMap } = route;
    const { queryParams } = route;
    const queryParamsMap = convertToParamMap(queryParams);

    // Collect route data from the route tree (including parent routes)
    const data: Record<string, unknown> = {};
    let currentRoute: RouterStateSnapshot['root'] | null = route;
    while (currentRoute) {
      if (currentRoute.data) {
        Object.assign(data, currentRoute.data);
      }
      currentRoute = currentRoute.parent;
    }

    // Only return an object including the URL, params, query params, and data
    // instead of the entire snapshot
    return { url, paramMap, queryParamsMap, data: Object.keys(data).length > 0 ? data : undefined };
  }
}
